import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import '../../styles/skeletons.css';

/**
 * SkeletonCardGrid — shimmer placeholder grid shown while product/animal
 * card lists load. Pure CSS animation (see styles/skeletons.css); honors
 * prefers-reduced-motion. Mirrors the real grid's Col breakpoints so the
 * layout doesn't jump when content arrives.
 */
function SkeletonCard() {
  return (
    <div className="ff-skeleton-card" aria-hidden="true">
      <div className="ff-skeleton ff-skeleton-card__img" />
      <div className="ff-skeleton-card__body">
        <div className="ff-skeleton ff-skeleton-card__line ff-skeleton-card__line--wide" />
        <div className="ff-skeleton ff-skeleton-card__line ff-skeleton-card__line--mid" />
        <div className="ff-skeleton ff-skeleton-card__line ff-skeleton-card__line--short" />
      </div>
    </div>
  );
}

function SkeletonCardGrid({ count = 8 }) {
  return (
    <Row className="g-4" role="status" aria-label="Loading products">
      {Array.from({ length: count }, (_, i) => (
        <Col key={i} xs={12} sm={6} md={4}>
          <SkeletonCard />
        </Col>
      ))}
    </Row>
  );
}

SkeletonCardGrid.propTypes = {
  count: PropTypes.number,
};

export { SkeletonCard };
export default SkeletonCardGrid;
